/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
 * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
 */
// tslint:disable
import { AsyncResult, callActionOrExecute, DataServiceQuery, IContext, IDataServiceRequest } from '@msdyn365-commerce/retail-proxy';
// @ts-ignore
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
import * as DataServiceEntities from './DataServiceEntities.g';

function simplePingPostQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function simplePingPostInput(): IDataServiceRequest {
    const query = simplePingPostQuery();
    return query.createDataServiceRequestForOperation('SimplePingPost', true, '', 'false', { bypassCache: 'get', returnEntity: '' }, {});
}

export function simplePingPostAsync(context: IContext): AsyncResult<boolean> {
    const request = simplePingPostInput();
    return callActionOrExecute<boolean>(request, context.callerContext);
}

function simplePingGetQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function simplePingGetInput(): IDataServiceRequest {
    const query = simplePingGetQuery();
    return query.createDataServiceRequestForOperation('SimplePingGet', false, '', 'false', { bypassCache: 'get', returnEntity: '' }, {});
}

export function simplePingGetAsync(context: IContext): AsyncResult<boolean> {
    const request = simplePingGetInput();
    return callActionOrExecute<boolean>(request, context.callerContext);
}

// @ts-ignore
function aAA_ContactusQuery(email?: string): DataServiceQuery {
    const key = email ? { Email: email } : null;
    return new DataServiceQuery('AAA_Contactus', 'AAA_Contactus', DataServiceEntities.AAA_ContactusExtensionClass, key);
}

export function createContactusInput(contactus: DataServiceEntities.IAAA_Contactus): IDataServiceRequest {
    const query = aAA_ContactusQuery();
    return query.createDataServiceRequestForOperation(
        'Contactus',
        true,
        DataServiceEntities.AAA_ResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IAAA_Response' },
        { contactus: contactus }
    );
}

export function contactusAsync(
    context: IContext,
    contactus: DataServiceEntities.IAAA_Contactus
): AsyncResult<DataServiceEntities.IAAA_Response> {
    const request = createContactusInput(contactus);
    return callActionOrExecute<DataServiceEntities.IAAA_Response>(request, context.callerContext);
}

// @ts-ignore
function aAA_SubscribeQuery(email?: string): DataServiceQuery {
    const key = email ? { Email: email } : null;
    return new DataServiceQuery('AAA_Subscribe', 'AAA_Subscribe', DataServiceEntities.AAA_SubscribeExtensionClass, key);
}

export function createSubscribeInput(email: string): IDataServiceRequest {
    const query = aAA_SubscribeQuery();
    return query.createDataServiceRequestForOperation(
        'Subscribe',
        true,
        DataServiceEntities.AAA_ResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IAAA_Response' },
        { email: email }
    );
}

export function subscribeAsync(context: IContext, email: string): AsyncResult<DataServiceEntities.IAAA_Response> {
    const request = createSubscribeInput(email);
    return callActionOrExecute<DataServiceEntities.IAAA_Response>(request, context.callerContext);
}

// @ts-ignore
function aAA_RequestOrderQuery(b2CCustomerId?: string): DataServiceQuery {
    const key = b2CCustomerId ? { B2CCustomerId: b2CCustomerId } : null;
    return new DataServiceQuery('AAA_RequestOrder', 'AAA_RequestOrder', DataServiceEntities.AAA_RequestOrderExtensionClass, key);
}

export function createGetOrderHistoryInput(
    selectTop: number,
    selectSkip: number,
    searchContract: DataServiceEntities.IAAA_OrderSearchContract
): IDataServiceRequest {
    const query = aAA_RequestOrderQuery();
    return query.createDataServiceRequestForOperation(
        'GetOrderHistory',
        true,
        DataServiceEntities.AAA_PagedResultResponse_1OfAAA_OrderLineExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IAAA_PagedResultResponse_1OfAAA_OrderLine' },
        { selectTop: selectTop, selectSkip: selectSkip, searchContract: searchContract }
    );
}

export function getOrderHistoryAsync(
    context: IContext,
    selectTop: number,
    selectSkip: number,
    searchContract: DataServiceEntities.IAAA_OrderSearchContract
): AsyncResult<DataServiceEntities.IAAA_PagedResultResponse_1OfAAA_OrderLine> {
    const request = createGetOrderHistoryInput(selectTop, selectSkip, searchContract);
    return callActionOrExecute<DataServiceEntities.IAAA_PagedResultResponse_1OfAAA_OrderLine>(request, context.callerContext);
}

export function createCreateRequestOrderInput(requestOrders: DataServiceEntities.IAAA_RequestOrder[]): IDataServiceRequest {
    const query = aAA_RequestOrderQuery();
    return query.createDataServiceRequestForOperation(
        'CreateRequestOrder',
        true,
        DataServiceEntities.AAA_CreateRequestOrderResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IAAA_CreateRequestOrderResponse' },
        { requestOrders: requestOrders }
    );
}

export function createRequestOrderAsync(
    context: IContext,
    requestOrders: DataServiceEntities.IAAA_RequestOrder[]
): AsyncResult<DataServiceEntities.IAAA_CreateRequestOrderResponse> {
    const request = createCreateRequestOrderInput(requestOrders);
    return callActionOrExecute<DataServiceEntities.IAAA_CreateRequestOrderResponse>(request, context.callerContext);
}

export function createCreateSavedDesignsInput(
    createSavedDesignsList: DataServiceEntities.IAAA_CreateSavedDesignsList[]
): IDataServiceRequest {
    const query = aAA_RequestOrderQuery();
    return query.createDataServiceRequestForOperation(
        'CreateSavedDesigns',
        true,
        DataServiceEntities.AAA_CreateSavedDesignsListResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IAAA_CreateSavedDesignsListResponse' },
        { createSavedDesignsList: createSavedDesignsList }
    );
}

export function createSavedDesignsAsync(
    context: IContext,
    createSavedDesignsList: DataServiceEntities.IAAA_CreateSavedDesignsList[]
): AsyncResult<DataServiceEntities.IAAA_CreateSavedDesignsListResponse> {
    const request = createCreateSavedDesignsInput(createSavedDesignsList);
    return callActionOrExecute<DataServiceEntities.IAAA_CreateSavedDesignsListResponse>(request, context.callerContext);
}

export function createDeleteSavedDesignsInput(
    deleteSavedDesignsList: DataServiceEntities.IAAA_DeleteSavedDesignsList[]
): IDataServiceRequest {
    const query = aAA_RequestOrderQuery();
    return query.createDataServiceRequestForOperation(
        'DeleteSavedDesigns',
        true,
        DataServiceEntities.AAA_DeleteSavedDesignsListResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IAAA_DeleteSavedDesignsListResponse' },
        { deleteSavedDesignsList: deleteSavedDesignsList }
    );
}

export function deleteSavedDesignsAsync(
    context: IContext,
    deleteSavedDesignsList: DataServiceEntities.IAAA_DeleteSavedDesignsList[]
): AsyncResult<DataServiceEntities.IAAA_DeleteSavedDesignsListResponse> {
    const request = createDeleteSavedDesignsInput(deleteSavedDesignsList);
    return callActionOrExecute<DataServiceEntities.IAAA_DeleteSavedDesignsListResponse>(request, context.callerContext);
}

export function createUpdateCommerceListInput(recId: number, snapShotId: string): IDataServiceRequest {
    const query = aAA_RequestOrderQuery();
    return query.createDataServiceRequestForOperation(
        'UpdateCommerceList',
        true,
        EntityClasses.CommerceListClass,
        'false',
        { bypassCache: 'get', returnEntity: 'Entities.CommerceList' },
        { recId: recId, snapShotId: snapShotId }
    );
}

export function updateCommerceListAsync(context: IContext, recId: number, snapShotId: string): AsyncResult<Entities.CommerceList> {
    const request = createUpdateCommerceListInput(recId, snapShotId);
    return callActionOrExecute<Entities.CommerceList>(request, context.callerContext);
}

export function createGetRequestOrderHistoryB2CInput(requestOrderId: string): IDataServiceRequest {
    const query = aAA_RequestOrderQuery();
    return query.createDataServiceRequestForOperation(
        'GetRequestOrderHistoryB2C',
        true,
        DataServiceEntities.AAA_GetRequestOrderHistoryB2CResponseExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IAAA_GetRequestOrderHistoryB2CResponse' },
        { requestOrderId: requestOrderId }
    );
}

export function getRequestOrderHistoryB2CAsync(
    context: IContext,
    requestOrderId: string
): AsyncResult<DataServiceEntities.IAAA_GetRequestOrderHistoryB2CResponse> {
    const request = createGetRequestOrderHistoryB2CInput(requestOrderId);
    return callActionOrExecute<DataServiceEntities.IAAA_GetRequestOrderHistoryB2CResponse>(request, context.callerContext);
}

export function createGetRequestOrderB2CInput(requestOrderId: string): IDataServiceRequest {
    const query = aAA_RequestOrderQuery();
    return query.createDataServiceRequestForOperation(
        'GetRequestOrderB2C',
        true,
        DataServiceEntities.AAA_GetRequestOrderB2CResponseExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IAAA_GetRequestOrderB2CResponse' },
        { requestOrderId: requestOrderId }
    );
}

export function getRequestOrderB2CAsync(
    context: IContext,
    requestOrderId: string
): AsyncResult<DataServiceEntities.IAAA_GetRequestOrderB2CResponse> {
    const request = createGetRequestOrderB2CInput(requestOrderId);
    return callActionOrExecute<DataServiceEntities.IAAA_GetRequestOrderB2CResponse>(request, context.callerContext);
}

export function createUpdateRequestOrderInput(requestOrderId: string, lineNum: number, status: number): IDataServiceRequest {
    const query = aAA_RequestOrderQuery();
    return query.createDataServiceRequestForOperation(
        'UpdateRequestOrder',
        true,
        DataServiceEntities.AAA_ResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IAAA_Response' },
        { requestOrderId: requestOrderId, lineNum: lineNum, status: status }
    );
}

export function updateRequestOrderAsync(
    context: IContext,
    requestOrderId: string,
    lineNum: number,
    status: number
): AsyncResult<DataServiceEntities.IAAA_Response> {
    const request = createUpdateRequestOrderInput(requestOrderId, lineNum, status);
    return callActionOrExecute<DataServiceEntities.IAAA_Response>(request, context.callerContext);
}

export function createGetB2BCustomerIdInput(b2cCustomerId: string): IDataServiceRequest {
    const query = aAA_RequestOrderQuery();
    return query.createDataServiceRequestForOperation(
        'GetB2BCustomerId',
        true,
        DataServiceEntities.AAA_GetB2BCustomerIdResponseExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IAAA_GetB2BCustomerIdResponse' },
        { b2cCustomerId: b2cCustomerId }
    );
}

export function getB2BCustomerIdAsync(
    context: IContext,
    b2cCustomerId: string
): AsyncResult<DataServiceEntities.IAAA_GetB2BCustomerIdResponse> {
    const request = createGetB2BCustomerIdInput(b2cCustomerId);
    return callActionOrExecute<DataServiceEntities.IAAA_GetB2BCustomerIdResponse>(request, context.callerContext);
}

export function createGetBMAStockistInput(): IDataServiceRequest {
    const query = aAA_RequestOrderQuery();
    return query.createDataServiceRequestForOperation(
        'GetBMAStockist',
        true,
        DataServiceEntities.AAA_GetBMAStockistResponseExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IAAA_GetBMAStockistResponse' },
        {}
    );
}

export function getBMAStockistAsync(context: IContext): AsyncResult<DataServiceEntities.IAAA_GetBMAStockistResponse> {
    const request = createGetBMAStockistInput();
    return callActionOrExecute<DataServiceEntities.IAAA_GetBMAStockistResponse>(request, context.callerContext);
}

export function createGetBMAPriceFactorMatrixInput(bmaStockistId: string): IDataServiceRequest {
    const query = aAA_RequestOrderQuery();
    return query.createDataServiceRequestForOperation(
        'GetBMAPriceFactorMatrix',
        true,
        DataServiceEntities.AAA_GetBMAPriceFactorMatrixResponseExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IAAA_GetBMAPriceFactorMatrixResponse' },
        { bmaStockistId: bmaStockistId }
    );
}

export function getBMAPriceFactorMatrixAsync(
    context: IContext,
    bmaStockistId: string
): AsyncResult<DataServiceEntities.IAAA_GetBMAPriceFactorMatrixResponse> {
    const request = createGetBMAPriceFactorMatrixInput(bmaStockistId);
    return callActionOrExecute<DataServiceEntities.IAAA_GetBMAPriceFactorMatrixResponse>(request, context.callerContext);
}

export function createUpdateBMAPriceFactorMatrixInput(
    bmaPriceFactorMatrix: DataServiceEntities.IAAA_RetailBMAPriceFactorMatrixContract[]
): IDataServiceRequest {
    const query = aAA_RequestOrderQuery();
    return query.createDataServiceRequestForOperation(
        'UpdateBMAPriceFactorMatrix',
        true,
        DataServiceEntities.AAA_UpdateBMAPriceFactorMatrixResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IAAA_UpdateBMAPriceFactorMatrixResponse' },
        { bmaPriceFactorMatrix: bmaPriceFactorMatrix }
    );
}

export function updateBMAPriceFactorMatrixAsync(
    context: IContext,
    bmaPriceFactorMatrix: DataServiceEntities.IAAA_RetailBMAPriceFactorMatrixContract[]
): AsyncResult<DataServiceEntities.IAAA_UpdateBMAPriceFactorMatrixResponse> {
    const request = createUpdateBMAPriceFactorMatrixInput(bmaPriceFactorMatrix);
    return callActionOrExecute<DataServiceEntities.IAAA_UpdateBMAPriceFactorMatrixResponse>(request, context.callerContext);
}

export function createCreateB2CCartServiceInput(b2cCart: DataServiceEntities.IAAA_B2CCart[]): IDataServiceRequest {
    const query = aAA_RequestOrderQuery();
    return query.createDataServiceRequestForOperation(
        'CreateB2CCartService',
        true,
        DataServiceEntities.AAA_CreateB2CCartResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IAAA_CreateB2CCartResponse' },
        { b2cCart: b2cCart }
    );
}

export function createB2CCartServiceAsync(
    context: IContext,
    b2cCart: DataServiceEntities.IAAA_B2CCart[]
): AsyncResult<DataServiceEntities.IAAA_CreateB2CCartResponse> {
    const request = createCreateB2CCartServiceInput(b2cCart);
    return callActionOrExecute<DataServiceEntities.IAAA_CreateB2CCartResponse>(request, context.callerContext);
}

export function createDeleteB2CCartByBMASnapshotIdInput(bMASnapshotId: string, recId: number): IDataServiceRequest {
    const query = aAA_RequestOrderQuery();
    return query.createDataServiceRequestForOperation(
        'DeleteB2CCartByBMASnapshotId',
        true,
        DataServiceEntities.AAA_DeleteB2CCartByBMASnapshotIdResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IAAA_DeleteB2CCartByBMASnapshotIdResponse' },
        { bMASnapshotId: bMASnapshotId, recId: recId }
    );
}

export function deleteB2CCartByBMASnapshotIdAsync(
    context: IContext,
    bMASnapshotId: string,
    recId: number
): AsyncResult<DataServiceEntities.IAAA_DeleteB2CCartByBMASnapshotIdResponse> {
    const request = createDeleteB2CCartByBMASnapshotIdInput(bMASnapshotId, recId);
    return callActionOrExecute<DataServiceEntities.IAAA_DeleteB2CCartByBMASnapshotIdResponse>(request, context.callerContext);
}

export function createGetSavedDesignsInput(): IDataServiceRequest {
    const query = aAA_RequestOrderQuery();
    return query.createDataServiceRequestForOperation(
        'GetSavedDesigns',
        false,
        DataServiceEntities.AAA_GetSavedDesignsListResponseExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IAAA_GetSavedDesignsListResponse' },
        {}
    );
}

export function getSavedDesignsAsync(context: IContext): AsyncResult<DataServiceEntities.IAAA_GetSavedDesignsListResponse> {
    const request = createGetSavedDesignsInput();
    return callActionOrExecute<DataServiceEntities.IAAA_GetSavedDesignsListResponse>(request, context.callerContext);
}

export function createGetRequestOrderInput(requestOrderId: string): IDataServiceRequest {
    const query = aAA_RequestOrderQuery();
    return query.createDataServiceRequestForOperation(
        'GetRequestOrder',
        false,
        DataServiceEntities.AAA_GetRequestOrderResponseExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IAAA_GetRequestOrderResponse' },
        { requestOrderId: requestOrderId }
    );
}

export function getRequestOrderAsync(
    context: IContext,
    requestOrderId: string
): AsyncResult<DataServiceEntities.IAAA_GetRequestOrderResponse> {
    const request = createGetRequestOrderInput(requestOrderId);
    return callActionOrExecute<DataServiceEntities.IAAA_GetRequestOrderResponse>(request, context.callerContext);
}

export function createGetB2CCartServiceInput(): IDataServiceRequest {
    const query = aAA_RequestOrderQuery();
    return query.createDataServiceRequestForOperation(
        'GetB2CCartService',
        false,
        DataServiceEntities.AAA_GetB2CCartResponseExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IAAA_GetB2CCartResponse' },
        {}
    );
}

export function getB2CCartServiceAsync(context: IContext): AsyncResult<DataServiceEntities.IAAA_GetB2CCartResponse> {
    const request = createGetB2CCartServiceInput();
    return callActionOrExecute<DataServiceEntities.IAAA_GetB2CCartResponse>(request, context.callerContext);
}
